export const workerCode = `
function nanoid(e=21){let t="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-_",n="";return crypto.getRandomValues(new Uint8Array(e)).forEach(e=>{n+=t[e%t.length]}),n}const maxLevel=6,createDescendants=(e,[t,n])=>{let s=[];for(let r=n+1;r<e[t].length;r++)"-"!==e[t][r]&&s.push([e[t][r],r]);return s},createData=({tempMap:e,name:t,slice:n,info:s})=>{if(e?.[t]){let r=e[t],a=new Set(r.descendants.map(e=>e.toString()));n.forEach(e=>{let t=e.toString();a.has(t)||(r.descendants.push(e),a.add(t))})}else e[t]={id:nanoid(),name:t,descendants:n,selected:!0,show:!0,info:s.join(" > ")};return e},createRefs=({perLevel:e,col:t,row:n,main:s,info:r,name:a})=>{let l=e[t][a],o="-"===r[n][0],c=r[n][t],i=s[n][t],f=[];if(o){if(c!==i)for(let h=0;h<=6&&"-"!==s[n][h];h++)h!==t&&f.push([s[n][h],h]);else for(let d=t-1;d>=0;d--)f.push([s[n][d],d])}if(!o&&"-"===c){for(let $=0;$<=6&&"-"!==s[n][$];$++)$!==t&&f.push([s[n][$],$]);f.push([s[n][0],0])}f.length>0&&(e[t][a]={...l,info:"",refTargets:f})},processDepartments=async(e=[],t=[])=>{if([e].some(e=>0===e.length))return console.error("フィルター項目がありません"),{};let n=Array(e[0].length||0).fill(null).map(e=>({}));for(let s=0;s<e[0].length;s++){let r={};for(let a=0;a<e.length;a++){let l=e[a][s];if("-"===l)continue;let o=e[a].slice(0,s),c=createDescendants(e,[a,s]);n[s]=createData({tempMap:r,name:l,slice:c,info:o,col:s}),createRefs({perLevel:n,col:s,row:a,main:e,info:t,name:l})}}return n};self.onmessage=function(e){try{processDepartments(e.data[0],e.data[1]).then(e=>{self.postMessage(e)})}catch(t){console.error("Error inside worker:",t.message),self.postMessage({error:t})}}; `

/**
function nanoid(size = 21) {
  const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-_'
  let id = ''
  crypto.getRandomValues(new Uint8Array(size)).forEach((x) => {
    id += alphabet[x % alphabet.length]
  })
  return id
}

const maxLevel = 6

**
 * @function
 * @param { string[][]} main
 * @param { [number,number]} index // 行, 列
 *
const createDescendants = (main, [row, col]) => {
  // Pattern A-B-C
  //子孫の取得

  const slice = []

  for (let i = col + 1; i < main[row].length; i++) {
    if (main[row][i] !== '-') slice.push([main[row][i], i])
  }


  return slice
}

const createData = ({ tempMap, name, slice, info }) => {

  if (!tempMap?.[name]) {
    tempMap[name] = {
      id: nanoid(),
      name,
      descendants: slice,
      selected: true,
      show: true,
      info: info.join(' > ')
    }
  } else {
    const node = tempMap[name]
    const seen = new Set(node.descendants.map((x) => x.toString()))

    slice.forEach((item) => {
      const key = item.toString()

      if (!seen.has(key)) {
        node.descendants.push(item)
        seen.add(key)
      }
    })
  }


  return tempMap
}

//ーーA　パターン
const createRefs = ({ perLevel, col, row, main, info, name }) => {
  //階位階層で参照のためのロジックです
  const currentLevel = perLevel[col][name]
  const isRowMinus = info[row][0] === '-'
  const infoVal = info[row][col]
  const mainVal = main[row][col]

  const refTargets = []

  if (isRowMinus) {
    //列の最初の値が-な場合　--A パターンです

    if (infoVal !== mainVal) {
      //  |   -  |   -  |  A  | Original
      //  | (3)A | (3)A |  A  | Filter
      //  一致しないパターン
      for (let counter = 0; counter <= maxLevel && main[row][counter] !== '-'; counter++) {
        if (counter !== col) refTargets.push([main[row][counter], counter])
      }
    } else {
      //  |   -  |   -  |  A  | Original
      //  | (3)A | (3)A |  A  | Filtered
      //一致するパターンで 3番列が対象
      for (let counter = col - 1; counter >= 0; counter--) {
        refTargets.push([main[row][counter], counter])
      }
    }
  }

  if (!isRowMinus && infoVal === '-') {
    // | A | -  | B | - |
    // | A |(1)A| B | - |
    //  2番列が対象
    for (let counter = 0; counter <= maxLevel && main[row][counter] !== '-'; counter++) {
      if (counter !== col) refTargets.push([main[row][counter], counter])
    }
    // こちらは捨ててもいいと思いますが念のため
    refTargets.push([main[row][0], 0])
  }

  if (refTargets.length > 0) {
    perLevel[col][name] = { ...currentLevel, info: '', refTargets }
  }
}

// 組織の処理
const processDepartments = async (main = [], info = []) => {
  if ([main].some((e) => e.length === 0)) {
    console.error('フィルター項目がありません')
    return {}
  }

  //階層ごとの組織データ
  const perLevel = new Array(main[0].length || 0).fill(null).map((_) => ({}))

  for (let col = 0; col < main[0].length; col++) {
    const tempMap = {}

    for (let row = 0; row < main.length; row++) {
      const name = main[row][col]
      if (name === '-') continue

      const ancestors = main[row].slice(0, col)
      let slice = createDescendants(main, [row, col])

      perLevel[col] = createData({
        tempMap,
        name,
        slice: slice,
        info: ancestors,
        col,
      })

      createRefs({ perLevel, col, row, main, info, name })
    }
  }

  return perLevel
}

self.onmessage = function (e) {
  try {
    // Intentionally cause an error for demo
    processDepartments(e.data[0], e.data[1]).then((e) => {
      self.postMessage(e)
    })
  } catch (err) {
    console.error('Error inside worker:', err.message)
    // Optionally send error back to main thread
    self.postMessage({ error: err})
  }
}

*/
